import { render, staticRenderFns } from "./sys_module.vue?vue&type=template&id=33da41b3"
import script from "./sys_module.vue?vue&type=script&lang=js"
export * from "./sys_module.vue?vue&type=script&lang=js"
import style0 from "./sys_module.vue?vue&type=style&index=0&id=33da41b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports